import { Component, HostListener } from '@angular/core';
import { WindowComponent } from "sharedFeatures/window";
import { FeedbackPopupBodyComponent } from './feedback-popup-body.component';

@Component(
{
    selector: 'feedback-popup',
    templateUrl: '../window/window.component.html',
    styleUrls: ['../window/window.component.less']
})
export class FeedbackPopupComponent extends WindowComponent {
    width = 420;
    showClose = false;
    cornerRadius = 0;
    modal = false;
    topMargin = 0;

    windowContentBody = FeedbackPopupBodyComponent;

    testId = 'FeedbackPopup';

    public appElem: any = null; // AppComponent or AccountAppComponent

    getBodyComponent(): FeedbackPopupBodyComponent {
        return <FeedbackPopupBodyComponent>super.getBodyComponent();
    }

    @HostListener('window:resize')
    handleWindowResize(): void {
        this.setSizeAndShow();
    }

    public setSizeAndShow(): void {
        if (!this.appElem) return;

        this.r.setStyle(document.body, 'overflow', 'hidden');

        let x = this.appElem.offsetWidth - this.getWidth();
        let y = 0;

        this.setSize(this.getWidth(), this.appElem.offsetHeight);

        if (this.isHidden())
            this.show(x, y);
        else
            this.setPosition(x, y);

        this.r.setStyle(document.body, 'overflow', '');
    }
}
